(function (Drupal, $) {
  Drupal.behaviors.bodyCopy = {
    attach: function (context) {
      $(".body-copy, .accordion, .filter-accordion", context)
        .once("body-copy-processed")
        .addClass("processed")
        .find("img")
        .each(function () {
          setCaption($(this));
        });

      function setCaption(item) {
        if (item.width()) {
          item.wrap(
            "<div class='image-wrapper' data-align='" +
              item.data("align") +
              "'></div>"
          );
          if (item.data("caption")) {
            item.after(
              "<div class='image-caption' data-align='" +
                item.data("align") +
                "'>" +
                item.data("caption") +
                "</div>"
            );
            item.siblings(".image-caption").outerWidth(item.width());
          }
        } else {
          setTimeout(function () {
            setCaption(item);
          }, 200);
        }
      }

      $(".body-copy table, .accordion table")
        .once()
        .each(function () {
          $(this).wrap("<div class='table-wrapper'></div>");
        });
    },
  };
})(Drupal, jQuery);
